import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "ml-6" };
const _hoisted_2 = { class: "text-primary" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_date_picker = _resolveComponent("date-picker");
    const _component_Form = _resolveComponent("Form");
    const _component_modal = _resolveComponent("modal");
    return ($props.show)
        ? (_openBlock(), _createBlock(_component_modal, {
            key: 0,
            onClose: _cache[2] || (_cache[2] = ($event) => ($setup.closeModal()))
        }, {
            header: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('share.temporaryShareTitle')), 1)
            ]),
            default: _withCtx(() => [
                _createElementVNode("span", _hoisted_1, _toDisplayString(_ctx.$t('share.temporaryShareMessage')), 1),
                _createVNode(_component_Form, {
                    "form-data": $setup.shareItemForm,
                    "onUpdate:form-data": _cache[1] || (_cache[1] = ($event) => (($setup.shareItemForm) = $event)),
                    onSubmit: $setup.shareVaultItem,
                    onCancel: $setup.closeModal
                }, {
                    "custom-prepend": _withCtx(() => [
                        _createElementVNode("label", _hoisted_2, _toDisplayString(_ctx.$t(`forms.labels.shareUntil`)) + " * ", 1),
                        _createVNode(_component_date_picker, {
                            modelValue: $setup.shareExpiryDate,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => (($setup.shareExpiryDate) = $event))
                        }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                }, 8, ["form-data", "onSubmit", "onCancel"])
            ]),
            _: 1
        }))
        : _createCommentVNode("", true);
}
